import { OPEN_DRAWER, CLOSE_DRAWER, TOGGLE_SIDE_MENU, SHOW_OCCUPATION_POPUP } from '../constants';

const initialState = {
  isOpen: false,
  content: null,
  buttonArea: null,
  onClose: () => { },
  sideMenuOpen: false,
  showOccupationPopup: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_DRAWER: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case CLOSE_DRAWER: {
      return {
        ...initialState,
      };
    }


    case TOGGLE_SIDE_MENU:
      return {
        ...state,
        sideMenuOpen: action.payload ?? !state.sideMenuOpen
      };

    case SHOW_OCCUPATION_POPUP:
      return {
        ...state,
        showOccupationPopup: action.payload,
      };

    default:
      return state;
  }
};
